import { FC } from 'react';
import cn from 'classnames';

import { Member } from '@/entities/vfo/types';
import { CaseIcon } from '@/features/vfo/components/CaseIcon';
import { UnreadCount } from '@/features/vfo/components/UnreadCount';
import { ApiCaseResponseV2, ApiChatResponse } from '@/shared/api/generated/data-contracts';
import { getPersonFullName } from '@/shared/helpers/names';
import { dates } from '@/shared/utils/dates';

import {
  CaseTitle,
  ChatItem as StyledChatItem,
  ChatItemContent,
  DateText,
  LastMessage,
  Spaced,
} from './styled';

type ChatItemProps = {
  chat: ApiChatResponse;
  isActive: boolean;
  onClick: () => void;
  caseData?: ApiCaseResponseV2;
  memberData?: Member;
  unreadCount: number;
};

export const ChatItem: FC<ChatItemProps> = ({
  chat,
  isActive,
  onClick,
  caseData,
  memberData,
  unreadCount,
}) => {
  const lastMessage = chat.lastMessage;
  const chatTitle = memberData
    ? getPersonFullName(memberData, 'display')
    : chat.title ?? caseData?.title;

  return (
    <StyledChatItem className={cn({ active: isActive })} onClick={onClick}>
      <CaseIcon caseData={caseData} member={memberData} />
      <ChatItemContent>
        <Spaced>
          <CaseTitle>{chatTitle}</CaseTitle>
          {lastMessage?.createdAt && (
            <DateText>{dates.formatShortDate(lastMessage.createdAt)}</DateText>
          )}
        </Spaced>
        {lastMessage?.body && (
          <Spaced>
            <LastMessage>{lastMessage.body}</LastMessage>
            {unreadCount > 0 && (
              <UnreadCount
                style={{
                  position: 'static',
                }}
              >
                {unreadCount}
              </UnreadCount>
            )}
          </Spaced>
        )}
      </ChatItemContent>
    </StyledChatItem>
  );
};
